import { jsxs as e, jsx as l } from "react/jsx-runtime";
const c = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#rosette-discount-check-filled_svg__a)", children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "M12 2.001a3.2 3.2 0 0 1 2.113.797l.154.145.698.698c.192.19.442.31.71.341l.135.008h1a3.2 3.2 0 0 1 3.195 3.018l.005.182v1c0 .27.092.533.258.743l.09.1.697.698a3.2 3.2 0 0 1 .147 4.382l-.145.154-.698.698a1.2 1.2 0 0 0-.34.71l-.009.135v1a3.2 3.2 0 0 1-3.018 3.195l-.182.005h-1a1.2 1.2 0 0 0-.743.258l-.1.09-.698.697a3.2 3.2 0 0 1-4.382.147l-.154-.145-.698-.698a1.2 1.2 0 0 0-.71-.34l-.135-.009h-1a3.2 3.2 0 0 1-3.195-3.018l-.005-.182v-1a1.2 1.2 0 0 0-.258-.743l-.09-.1-.697-.698a3.2 3.2 0 0 1-.147-4.382l.145-.154.698-.698a1.2 1.2 0 0 0 .341-.71l.008-.135v-1l.005-.182a3.2 3.2 0 0 1 3.013-3.013l.182-.005h1a1.2 1.2 0 0 0 .743-.258l.1-.09.698-.697a3.2 3.2 0 0 1 2.27-.944m3.697 7.282a1 1 0 0 0-1.414 0l-3.293 3.292-1.293-1.292-.094-.083a1 1 0 0 0-1.32 1.497l2 2 .094.083a1 1 0 0 0 1.32-.083l4-4 .083-.094a1 1 0 0 0-.083-1.32"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "rosette-discount-check-filled_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  c as default
};
